import { useEffect } from 'react';

import { UPDATE_ACTIVE_TAB_TIMEOUT } from '../constants';
import commonStore from '../store/CommonStore';
import localStorageStore from '../store/LocalStorageStore';

export const useActiveTabSync = (): void => {
  useEffect(() => {
    const activeTabId = localStorageStore.initActiveTab();
    commonStore.setActiveTab(activeTabId);

    commonStore.checkActiveTab();

    const interval = setInterval(
      commonStore.checkActiveTab,
      UPDATE_ACTIVE_TAB_TIMEOUT,
    );
    return () => clearInterval(interval);
  }, []);
};
